import { ALL_SPREAD_DEFINITIONS } from './all-spreads.js';
export const SPREADS_BY_DIFFICULTY = {
    beginner: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.spread.difficulty === 'beginner'),
    intermediate: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.spread.difficulty === 'intermediate'),
    advanced: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.spread.difficulty === 'advanced'),
    initiatic: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.spread.difficulty === 'initiatic'),
};
//# sourceMappingURL=by-difficulty.js.map